<template>

  <div>
<FieldLabel v-if="prop.show" :label="item.name" :help="showFieldHelp ? fieldHelp : null" :field-id="item.id" :modal-key="modalKey" />
    <!-- Bouton Ajouter une grille vierge -->
    <v-row class="mb-4">
      <v-col cols="auto">
        <v-btn color="primary" @click="addGrille">+ Ajouter une grille</v-btn>
      </v-col>
    </v-row>

    <v-tabs
      :background-color="prop.class"
      v-model="tabs">
      <v-tab
        v-for="(grille, gIndex) in model"
        :key="gIndex">
        {{grille.nom}}
      </v-tab>
    
 
    <v-tabs-items v-model="tabs">
      <v-tab-item
        v-for="(grille, gIndex) in grillesTables"
        :key="gIndex"
      >
      Ref. : {{ model[gIndex].key }}
        <v-btn small color="error" @click="model = model.splice(gIndex,1)">
            <v-icon small>mdi-delete</v-icon> Supprimer la grille
        </v-btn>
      <v-text-field
      v-model="model[gIndex].nom"/>
        <v-card flat>
          <v-card-text>
                <v-row class="mb-2" dense>
                    <v-col cols="auto">
                    <v-btn small color="primary" @click="addHauteur(gIndex)">+ Ligne (Hauteur)</v-btn>
                    </v-col>
                    <v-col cols="auto">
                    <v-btn small color="primary" @click="addLargeur(gIndex)">+ Colonne (Largeur)</v-btn>
                    </v-col>
                </v-row>
                <template v-if="getHauteurs(grille).length && getLargeurs(grille).length">
                <v-simple-table dense>
                    <thead>
                    <tr>
                        <th>Hauteur \ Largeur</th>
                        <th v-for="(l, li) in grille.largeurs" :key="li">
                            <input
                            class="dim-input"
                            type="number"
                            :value="l"
                            @input="e => updateLargeur(gIndex, l, Number(e.target.value))"
                            />
                        <v-btn icon small color="error" @click="removeLargeur(gIndex, l)">
                            <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(h, hi) in grille.hauteurs" :key="hi">
                        <!-- Hauteur éditable -->
                        <td>
                            <input
                            class="dim-input"
                            type="number"
                            :value="h"
                            @input="e => updateHauteur(gIndex, h, Number(e.target.value))"
                            />
                        <v-btn icon small color="error" @click="removeHauteur(gIndex, h)">
                            <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                        </td>

                        <!-- Prix -->
                        <td v-for="(l, li) in grille.largeurs" :key="li">
                            <input
                            class="dim-input"
                            type="number"
                            :value="getPrix(gIndex, h, l)"
                            @input="val => setPrix(gIndex, h, l, Number(val.target.value))"
                            />
                        </td>
                    </tr>
                    </tbody>
                </v-simple-table>
                </template>
                <p v-else class="grey--text text--darken-1">
                    Grille vide. Ajoutez des lignes ou colonnes.
                </p>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>    
    </v-tabs>
  </div>

</template>



<script>
import mixinFields from '../../mixins/Fields'
import mixinConditionsFields from '../../mixins/conditionsFields'
    export default {
        name : 'AbaquE',

        mixins : [mixinFields,mixinConditionsFields],

        data: function() {
            return { 
                tabs : ''
            }
        },

        watch : { 

           valField(val) {
            
               this.model = val
               this.changeStoreOnField({item:this.item,model:this.model,page:this.modalKey})
           }

        },

        computed: {

            // Générer les hauteurs et largeurs d'une grille à partir de prixMap
            grillesTables() {

                if (!Array.isArray(this.model)) return [];

                return this.model.map(grille => {
                const prixMap = grille.prixMap || {};

                const hauteurs = Object.keys(prixMap)
                    .map(Number)
                    .sort((a, b) => a - b);

                const largeurs = [
                    ...new Set(
                    hauteurs.flatMap(h =>
                        Object.keys(prixMap[h] || {}).map(Number)
                    )
                    )
                ].sort((a, b) => a - b);

                return {
                    ...grille,      // 🔴 on garde nom, prixMap, etc.
                    hauteurs,
                    largeurs
                };
                });
            }
        },

        methods : {

            getHauteurs(grille) {
                let ee = Object.keys(grille.prixMap).map(Number).sort((a,b)=>a-b);
                return ee
            },

            getLargeurs(grille) {
                const hauteurs = Object.keys(grille.prixMap);
                const allLargeurs = hauteurs.flatMap(h => Object.keys(grille.prixMap[h]).map(Number));         
                let ee = [...new Set(allLargeurs)].sort((a,b)=>a-b);
                return ee
            },

            // --- Prix ---
            getPrix(grilleIndex, h, l) {
            const prixMap = this.model[grilleIndex].prixMap;
            if (!prixMap[h]) this.$set(prixMap, h, {});
            if (prixMap[h][l] === undefined) this.$set(prixMap[h], l, 0);
            return prixMap[h][l];
            },

            setPrix(grilleIndex, h, l, val) {
                
            const prixMap = this.model[grilleIndex].prixMap;
            if (!prixMap[h]) this.$set(prixMap, h, {});
            const prix = isNaN(val) ? 0 : val;
            this.$set(prixMap[h], l, prix);
            },

            // --- Ajouter/supprimer ligne/colonne ---
            addHauteur(grilleIndex) {
            const grille = this.model[grilleIndex];
            const hauteurs = Object.keys(grille.prixMap).map(Number);
            const newH = hauteurs.length ? Math.max(...hauteurs)+10 : 100;
            this.$set(grille.prixMap, newH, {});
            
            const largeurs = [...new Set(hauteurs.flatMap(h => Object.keys(grille.prixMap[h]).map(Number)))];
            if (largeurs.length === 0) largeurs.push(200);
            largeurs.forEach(l => this.$set(grille.prixMap[newH], l, 0));
            },

            addLargeur(grilleIndex) {
            const grille = this.model[grilleIndex];
            const hauteurs = Object.keys(grille.prixMap).map(Number);
            if (hauteurs.length === 0) {
                // pas de lignes → créer une ligne par défaut
                this.$set(grille.prixMap, 100, {200:0});
                return;
            }
            const largeurs = [...new Set(hauteurs.flatMap(h => Object.keys(grille.prixMap[h]).map(Number)))];
            const newL = largeurs.length ? Math.max(...largeurs)+10 : 200;
            hauteurs.forEach(h => this.$set(grille.prixMap[h], newL, 0));
            },

            removeHauteur(grilleIndex, h) {
            const grille = this.model[grilleIndex];
            this.$delete(grille.prixMap, h);
            },

            removeLargeur(grilleIndex, l) {
            const grille = this.model[grilleIndex];
            Object.keys(grille.prixMap).forEach(h => {
                this.$delete(grille.prixMap[h], l);
            });
            },

            // --- Mettre à jour hauteur/largeur après édition ---
            updateHauteur(grilleIndex, oldH, newH) {

            if (!newH || oldH === newH) return;

            const grille = this.model[grilleIndex];
            const prixMap = grille.prixMap || {};

            if(prixMap[newH]) {
                alert('non')
                return;
            }
            // si la nouvelle hauteur existe déjà → on merge
            if (!prixMap[newH]) {
                this.$set(prixMap, newH, {});
            }

            Object.keys(prixMap[oldH] || {}).forEach(l => {
                this.$set(prixMap[newH], l, prixMap[oldH][l]);
            });

            this.$delete(prixMap, oldH);
            },

            updateLargeur(grilleIndex, oldL, newL) {
            if (!newL || oldL === newL) return;

            const grille = this.model[grilleIndex];
            const prixMap = grille.prixMap || {};

            Object.keys(prixMap).forEach(h => {
                const row = prixMap[h];

                // si la nouvelle largeur n’existe pas → créer
                if (row[newL] === undefined) {
                this.$set(row, newL, row[oldL] || 0);
                }

                this.$delete(row, oldL);
            });
            },

            // --- Ajouter grille vierge ---
            addGrille() {
            const newNom = `grille${this.model.length+1}`;
            const newKey = this.randomKey(6);
            this.model.push({ nom: newNom, key:newKey, prixMap: {} });
            }

        },

    }

</script>

<style scoped>
.price-input {
  width: 70px;
  padding: 2px 4px;
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.dim-input {
  width: 60px;
  padding: 2px 4px;
  text-align: center;
  font-weight: bold;
  border: 1px solid #999;
  border-radius: 4px;
}
</style>

